import React, { useEffect, useState } from "react";
import { Combobox, Option } from "@fluentui/react-components";
import raw from "../../data/countries.json";

const countries = Object.entries(raw).map(([code, name]) => ({ code, name }));

export default function CountryCombobox({ value, onChange }) {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [typedText, setTypedText] = useState("");

  useEffect(() => {
    const match = countries.find((c) => c.code === value);
    setSelectedCountry(match ?? null);
    setTypedText(match?.name ?? "");
  }, [value]);

  const handleInputChange = (event) => {
    const input = event.target.value.toLowerCase();
    setTypedText(event.target.value);

    const match = countries.find(
      (c) =>
        c.name.toLowerCase().includes(input) ||
        c.code.toLowerCase().includes(input)
    );

    if (match) setSelectedCountry(match);
  };

  const handleOptionSelect = (_, data) => {
    const match = countries.find((c) => c.code === data.optionValue);
    if (match) {
      setSelectedCountry(match);
      setTypedText(match.name);
      onChange?.(match.code);
    }
  };

  return (
    <Combobox
      freeform
      value={typedText}
      onChange={handleInputChange}
      onOptionSelect={handleOptionSelect}
      placeholder="Select country"
    >
      {countries.map((c) => (
        <Option key={c.code} value={c.code}>
          {c.name}
        </Option>
      ))}
    </Combobox>
  );
}
